import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { formatBookingObject } from '../other/sharedFunctions';
import { get, push } from "firebase/database";

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const   {
        bookingRef,
        settingsRef,
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    let settings, data;
    try {
        const settingsdata = await get(settingsRef);
        settings = settingsdata.val();
        data = await formatBookingObject(bookingData, settings);
    } catch (error) {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: (error && (error.code ? error.code + ": " : "") + (error.message || error.toString())) || "Booking error",
        });
        return;
    }


    // Push a socios: lo envía notifyDriversOnNewBooking (Cloud Function) al crear el booking.

    // Firebase RTDB lanza una excepción SÍNCRONA si el objeto contiene algún
    // valor `undefined` (p. ej. carImage/commission_type ausentes, o campos
    // undefined dentro de instructionData). Ese throw NO lo atrapa el .catch de
    // la promesa, por lo que la reserva nunca se creaba y el estado quedaba en
    // "loading" para siempre (spinner infinito). Saneamos el objeto quitando los
    // undefined y envolvemos el push en try/catch para reportar el error.
    const cleanData = removeUndefined(data);

    try {
        const res = await push(bookingRef, cleanData);
        const bookingKey = res.key;
        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id: bookingKey,
                mainData: {
                    ...cleanData,
                    id: bookingKey,
                },
            },
        });
    } catch (error) {
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: (error && ((error.code ? error.code + ": " : "") + (error.message || error.toString()))) || "Booking error",
        });
    }
};

// Elimina recursivamente las claves con valor `undefined` (y funciones) para
// evitar que Firebase rechace toda la escritura.
const removeUndefined = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map((v) => (v && typeof v === 'object' ? removeUndefined(v) : v));
    }
    if (obj && typeof obj === 'object') {
        const out = {};
        Object.keys(obj).forEach((k) => {
            const v = obj[k];
            if (v === undefined || typeof v === 'function') return;
            // Firebase rechaza NaN/Infinity ("value argument contains NaN").
            // Los tratamos como ausentes para nunca romper la escritura.
            if (typeof v === 'number' && !Number.isFinite(v)) return;
            out[k] = (v && typeof v === 'object') ? removeUndefined(v) : v;
        });
        return out;
    }
    return obj;
};

